import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Stack, Tabs, Tab, Typography, Drawer } from "@mui/material";
import Filtericon from "../../../assets/images/task/Filter_icon.svg";

import WorkTrackingList from "./WorkTrackingList";
import { handleGetWorkTrackingList } from "../../../appStore/actions/ArkchatGroup/action";
import useAppSelectors from "../../../customHooks/useAppSelectors";
import {
  WORK_TRACKING_FILTER_QUERY_CONFIG,
  filtersidebarmenu,
  workTrackingSidebarmenu,
} from "../../../utils/constant";
import { leftOverlayDrawerSx } from "../../../assets/commonFunction";
import Filter from "../../task/Filter/Filter";
import TaskTeamList from "../Task/Drawer/TaskTeamList";
import { useGroupTaskApprovalLogic } from "../../../customHooks/useGroupTaskApprovalLogic";

const classes = {
  Tabs: {
    minHeight: "38px",
    alignItems: "center",
    "& .MuiTabs-flexContainer": {},
    "@media (max-width: 63em)": {},
    "& .MuiTab-root.Mui-selected": {
      background: "#183243",
      color: "#fff",
    },
  },
  tabs: {
    marginLeft: "0.5rem",
    minWidth: "unset",
    color: "#183243",
    textTransform: "none",
    minHeight: "1.8rem",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: "15px 12px 15px 12px !important",
    maxHeight: "30px",
    lineHeight: "normal",
    background: "#fff",
    borderRadius: "3px",
    border: "1px solid #000000",
  },
  filterFab: {
    position: "fixed",
    bottom: "1.5rem",
    right: "1.5rem",
    width: "52px",
    height: "52px",
    borderRadius: "50%",
    backgroundColor: "#DB0011",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
    zIndex: 1100,
  },
};

const TabPanel = ({ children, value, index }) => (
  <div hidden={value !== index} style={{ height: "100%" }}>
    {value === index && children}
  </div>
);

const WorkTrackingListTab = ({
  setShowSidebar,
  handleClickTaskUpdate,
  handleViewThreadClick,
  currentHomeIndexTab,
  setSideBarOpen,
  filterActive,
  setFilterActive,
  groupActive,
  setGroupActive,
  sidebarLeft,
  setSidebarLeft,
}) => {
  const { currentUserData } = useAppSelectors();
  const [isFilterDrawerOpen, setFilterDrawerOpen] = useState(false);

  const noopAnalytics = () => () => { };

  const {
    selectedTabGroup,
    buttonDrawer,
    recipientDetails,
    filterChecked,
    tabValue,
    selectedMember,
    selectedDateRange,
    setSelectedDateRange,
    handleCheckedFilter,
    handleClearFilter,
    handleApplyTaskFilter,
    refreshList,
    handleSelectMemberCheck,
    handleTabClick,
    handleChange,
    handlecloseTeamlist,
  } = useGroupTaskApprovalLogic({
    listApi: handleGetWorkTrackingList,
    analyticsApi: noopAnalytics,
    filterConfig: WORK_TRACKING_FILTER_QUERY_CONFIG,
    currentUserData,
    setFilterActive,
    setSideBarOpen,
    setGroupActive,
    filterActive,
    groupActive,
    setSidebarLeft,
    sidebarLeft,
    setShowSidebar,
  });

  // Live updates: a task/approval was created or updated somewhere. Re-run
  // the current query once things settle, if it's in the group being tracked
  // (or any group, in "All groups").
  const workTrackingChange = useSelector(
    (state) => state?.localAppReducer?.workTrackingChange,
  );
  const refreshTimerRef = useRef(null);
  // The latest render's refresh, so a delayed refresh uses the group and
  // filters on screen when it fires, not the ones when the change arrived.
  const refreshRef = useRef(refreshList);
  refreshRef.current = refreshList;
  useEffect(() => {
    if (!workTrackingChange || !selectedTabGroup?.id) return;
    const inScope =
      selectedTabGroup?.isAllGroups ||
      workTrackingChange.pnId === selectedTabGroup?.pnId;
    if (!inScope) return;
    clearTimeout(refreshTimerRef.current);
    refreshTimerRef.current = setTimeout(() => refreshRef.current(), 800);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workTrackingChange?.seq]);
  useEffect(() => () => clearTimeout(refreshTimerRef.current), []);

  return (
    <Box width="100%">
      <Stack direction="row" width="100%">
        <Box direction="column" gap="0.2rem" width="100%">
          <Box direction="row" display="flex" gap="0.2rem" alignItems="center" width="100%">
            <Tabs
              value={tabValue}
              onChange={handleChange}
              TabIndicatorProps={{ style: { backgroundColor: "transparent" } }}
              sx={classes.Tabs}
            >
              <Tab disableRipple sx={classes.tabs} onClick={() => handleTabClick(0)} label="All" />
              <Tab disableRipple sx={classes.tabs} onClick={() => handleTabClick(1)} label="Mine" />
              <Tab disableRipple sx={classes.tabs} onClick={() => handleTabClick(2)} label="Team" />
              <Tab disableRipple sx={classes.tabs} onClick={() => handleTabClick(3)} label="Archive" />
            </Tabs>
          </Box>

          <Box display="flex" gap="0.2rem" marginTop="1rem">
            <Box
              sx={{
                flex: 1,
                minWidth: 0,
                overflowY: "auto",
                height: "calc(100vh - 10rem)",
                "&::-webkit-scrollbar": { width: "4px" },
                "&::-webkit-scrollbar-thumb": { backgroundColor: "#B0B0B0", borderRadius: "10px" },
              }}
            >
              {selectedTabGroup?.id ? (
                [0, 1, 2, 3].map((index) => (
                  <TabPanel key={index} value={tabValue} index={index}>
                    <WorkTrackingList
                      handleClickTaskUpdate={handleClickTaskUpdate}
                      handleViewThreadClick={handleViewThreadClick}
                      handleApplyFilter={handleApplyTaskFilter}
                      filterChecked={filterChecked}
                      recipientDetails={recipientDetails}
                    />
                  </TabPanel>
                ))
              ) : (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="100%"
                >
                  <Typography fontSize="0.9rem" color="#888">
                    Select a group to view its tracked work
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        </Box>

        <Drawer sx={{ zIndex: 1202 }} open={buttonDrawer?.isOpen} anchor="right">
          {buttonDrawer?.header === "Team" && (
            <TaskTeamList
              recipientDetails={recipientDetails}
              handlecloseTeamlist={handlecloseTeamlist}
              handleSelectTaskMemberCheck={handleSelectMemberCheck}
              selectedTaskmember={selectedMember}
            />
          )}
        </Drawer>
      </Stack>

      <Box sx={classes.filterFab} onClick={() => setFilterDrawerOpen(true)}>
        <img src={Filtericon} alt="filter" style={{ width: "22px", height: "23px" }} />
      </Box>

      <Drawer
        sx={{ zIndex: 1202, ...leftOverlayDrawerSx }}
        open={isFilterDrawerOpen}
        anchor="left"
        variant="persistent"
      >
        <Box sx={{ width: "100%", height: "100%" }}>
          <Filter
            onClose={() => setFilterDrawerOpen(false)}
            setSideBarOpen={setSideBarOpen}
            handleCheckedFilter={handleCheckedFilter}
            filterChecked={filterChecked}
            sidebarmenudata={workTrackingSidebarmenu}
            filterbarmenudata={filtersidebarmenu}
            handleClearFilter={handleClearFilter}
            handleApplyFilter={handleApplyTaskFilter}
            currentHomeIndexTab={currentHomeIndexTab}
            selectedDateRange={selectedDateRange}
            setSelectedDateRange={setSelectedDateRange}
          />
        </Box>
      </Drawer>
    </Box>
  );
};

export default WorkTrackingListTab;
